
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/itinerary-list/[destinationSlug]",
      function () {
        return require("private-next-pages/itinerary-list/[destinationSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/itinerary-list/[destinationSlug]"])
      });
    }
  